var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "location-search" },
    [
      _c(
        "el-select",
        {
          staticClass: "autocomplete-input",
          attrs: {
            filterable: "",
            remote: "",
            placeholder: "可搜索地址或经纬度",
            "remote-method": _vm.lazySearch,
            loading: _vm.loading
          },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        [
          _c("template", { slot: "prefix" }, [
            _c("i", { staticClass: "el-icon-search" })
          ]),
          _vm._l(_vm.items, function(item) {
            return _c(
              "el-option",
              { key: item.name, attrs: { value: item.name } },
              [
                _c("div", { staticClass: "item-container" }, [
                  _c("div", { staticClass: "item-left" }, [
                    _vm._v(" " + _vm._s(item.name) + " "),
                    _c("span", { staticClass: "desc" }, [
                      _vm._v(_vm._s(item.desc))
                    ])
                  ]),
                  _c("div", { staticClass: "item-right" }, [
                    item.district
                      ? _c("i", {
                          staticClass: "el-icon-crop",
                          on: {
                            click: function($event) {
                              return _vm.drawDistrict(item)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("i", {
                      staticClass: "el-icon-location",
                      on: {
                        click: function($event) {
                          return _vm.drawPoint(item)
                        }
                      }
                    })
                  ])
                ])
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }